import * as React from 'react';
import { AppContext } from '@src/context/store';
import { PrivacyPolicyCard } from './privacy-policy';
import { getPrivacyPolicyType } from '@src/context/selectors/app-settings';
import { getKBLinks } from '@src/context/selectors/ui-settings';

export const PrivacyPolicyContainer = () => {
  const store = React.useContext(AppContext);

  return (
    <PrivacyPolicyCard
      privacyPolicyType={getPrivacyPolicyType(store)}
      updatePendingAppSettings={store.updatePendingAppSettings}
      notificationKBLink={getKBLinks(store).CreatingAPrivacyPolicy}
    />
  );
};
